// extracted by mini-css-extract-plugin
module.exports = {"container":"Product_container__twHLj","title":"Product_title__Lks7Z","separator":"Product_separator__UzjRB","image-container":"Product_image-container__2YTAI"};